// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"styles_Tooltip__RUf0s","LimitedWidth":"styles_LimitedWidth__2I7Ta","Icon":"styles_Icon__2R4DS"};